import React, { useContext, useEffect, useState, useCallback } from 'react';
import { Helmet } from 'react-helmet';
import FaqMainLayout from '../layouts/FaqMainLayout';
import styled from '@emotion/styled';
import { FaqContext } from '../context/FaqProvider';
import { useParams } from 'react-router-dom';
import RichTextRenderer from '../utils/RichTextRenderer';
import { PrivacyIcon } from '../svg';
import { useBrandDetails } from 'dw-au-react-components';

const StyledAccordionLayout = styled.div`
	background: #ffffff;
	border: 1px solid #e3e3e3;
	border-radius: 4px;
	padding: 20px;
`;

function Legal() {
	const brandData = useBrandDetails();
	let { section = 'wine-plans' } = useParams();
	const { privacyAndTerms } = useContext(FaqContext);
	const [data, setData] = useState(null);

	const filteredData = useCallback(() => {
		const data1 = privacyAndTerms.filter((data) => {
			return data.slug === section;
		});
		setData(data1);
	}, [privacyAndTerms, section]);

	useEffect(() => {
		filteredData();
	}, [filteredData]);

	return (
		<FaqMainLayout>
			<Helmet>
				<title>
					{data && data[0]?.title ? data[0]?.title + ' - ' : ''}
					{brandData.name}
				</title>
			</Helmet>

			<StyledAccordionLayout>
				{data && (
					<RichTextRenderer
						content={data[0].content}
						headingIcon={PrivacyIcon}
					/>
				)}
			</StyledAccordionLayout>
		</FaqMainLayout>
	);
}

export default Legal;
